/**
 * @file DarkOverlay.js
 * @module src/js/components/DarkOverlay
 * @description
 * **A dark overlay component that adjusts opacity based on the current theme.**
 * - Covers the entire viewport with a semi-transparent dark layer.
 * - Opacity changes smoothly when switching between light and dark themes.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Integrated themeTransitionDuration from ThemeProvider for consistent transitions. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { useTheme } from '../contexts/ThemeProvider';

export default function DarkOverlay() {
    const { theme, themeTransitionDuration } = useTheme();

    return (
        <div id='dark-overlay'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 1)', // Adjust opacity to control darkness
                opacity: theme === 'dark' ? 0.2 : 0,
                transition: `opacity ${themeTransitionDuration}s ease-in-out`,
                pointerEvents: 'none', // Prevent blocking clicks
                zIndex: 999999
            }}
        />
    );
}